import React, {useEffect} from 'react';
import {get} from 'lodash';
import {gql} from '@apollo/client';
import {startCase, toLower} from 'lodash';

import client from '../../src/graphql/client';
import refactorHb from '../../src//data-restructure/multimedia/hero-banner-small-v2-2023';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorRespImg from '../../src/data-restructure/ui/resp-img';
import seoQuery from '../../src/graphql/queries/seo';

import AmbassadorsPage from '../../src/containers/Ambassadors/AmbassadorsPage';
  
const Ambassadors = (props) => {
  useEffect(() => {
    // This will only happen in preview mode (when domain isn't available in getStaticPaths)
    const currentDomain = props.countryProps.assignedDomain;
    if (props.meta.assignedDomains.length === 0 || (currentDomain.length === 1 && props.meta.assignedDomains.indexOf(currentDomain[0]) === -1)) {
      // To prevent any slow routing on development
      process.env.NODE_ENV === 'development' ?
        window.location.href = '/404'
      :
      Router.push('/404')
    }
  },[]);

  return (
  	<div>
      <AmbassadorsPage
        {...props}
      />
    </div>
  )
}

export async function getStaticPaths() {

  const GET_DYNAMIC_AMBASSADORS_QUERY = gql`
    query GET_AMBASSADORS_PATHS {
      ambassadors(first: 1000) {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_AMBASSADORS_QUERY
  });

  let paths = [];

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const ambassadors = get(result, 'data.ambassadors.nodes', []);
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz'

  ambassadors.forEach(item => {
    const uri = get(item, 'uri', null);
    const assignedDomains = get(item, 'acf_domains.assignedDomains', []);

    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        id: uri.replace('-ccau', '').replace('-ccnz', ''),
      }
    });
  });

  return { paths, fallback: 'blocking' }
}
  
export async function getStaticProps({ params }) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const GET_PAGE_CONTEXT = gql`
    query GET_AMBASSADOR_PAGE {
      pageBy(uri: "ambassadors?${countryCode}") {
        title
        seo {
          ${seoQuery}
        }
        uri
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcHeroBannerV22023 {
              fieldGroupName
              hb2Banners {
                hb2Title
                hb2Subtext
                hb2Image {
                  ${respImgQuery}
                }
                hb2VideoDesktop {
                  guid
                }
                hb2VideoMobile {
                  guid
                }
                hb2Link {
                  title
                  url
                  target
                }
              }
            }
          }
        }
      }
    }
  `

  const GET_AMBASSADORS = gql`
    query GET_AMBASSADOR($uri: String) {
      ambassadorBy(uri: $uri) {
        seo {
          ${seoQuery}
        }
        uri
        acf_domains {
          assignedDomains
        }
        title
        acf_ambassador {
          amSubtitle
          amDescription
          amFacebook
          amInstagram
          amLinkedin
          amTwitter
          amYoutube
          amPhoto {
            ${respImgQuery}
          }
          amHashtag
          amFbPageId
        }
      }
    }
  `

  const GET_ARTICLES_ALL = gql`
    query GET_ARTICLE {
      articles(first:1000) {
        nodes {
          uri
          title
          articleCategories {
            nodes {
              name
            }
          }
          acf_article {
            artTeaserCopy
            artThumbnailImage {
              ${respImgQuery}
            }
            artRelatedToAmbassador {
              ... on Ambassador {
                uri
              }
            }
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  const pageProps = await client.query({
    query: GET_AMBASSADORS,
    variables: {
      uri: `${params.id}?${countryCode}`
    }
  });

  const articlesProps = await client.query({
    query: GET_ARTICLES_ALL
  });

  if (pageProps) {
    const context = get(contextProps, 'data.pageBy', {});
    const seo = get(pageProps, 'data.ambassadorBy.seo', null);
    const uri = get(pageProps, 'data.ambassadorBy.uri', null);

    const hbData = get(context, 'acf_content_builder.contentBuilder', null);
    const heroBanner = hbData && hbData[0] ? refactorHb(hbData[0]) : null;

    const title = get(pageProps, 'data.ambassadorBy.title', null);
    const description = get(pageProps, 'data.ambassadorBy.acf_ambassador.amDescription', null);
    const image = get(pageProps, 'data.ambassadorBy.acf_ambassador.amPhoto', null);
    const facebook = get(pageProps, 'data.ambassadorBy.acf_ambassador.amFacebook', null);
    const instagram = get(pageProps, 'data.ambassadorBy.acf_ambassador.amInstagram', null);
    const youtube = get(pageProps, 'data.ambassadorBy.acf_ambassador.amYoutube', null);
    const linkedIn = get(pageProps, 'data.ambassadorBy.acf_ambassador.amLinkedin', null);
    const twitter = get(pageProps, 'data.ambassadorBy.acf_ambassador.amTwitter', null);

    // const relatedArticles = get(pageProps, 'data.ambassadorBy.author.articles.nodes', []).map(item => {
    //   item.uri = item.uri.replace('-ccau', '').replace('-ccnz', '');
    //   return item;
    // });
    // const relatedArticles = articles.filter(article => article.acf_article.artRelatedToAmbassador === title);
    var relatedArticles = [];
    if (get(articlesProps, 'data.articles.nodes', false)) {
      for (let i = 0; i < articlesProps.data.articles.nodes.length; i++) {
        let item = articlesProps.data.articles.nodes[i];
        let articleAmbassadorUri = get(item, 'acf_article.artRelatedToAmbassador[0].uri', null);
        if (articleAmbassadorUri == uri) {
          item.uri = item.uri.replace('-ccau', '').replace('-ccnz', '').replace(`-au-dealers`, '').replace(`-nz-dealers`, '');
          relatedArticles.push(item);
        }
      }
    }
    
    const assignedDomains = get(pageProps, 'data.ambassadorBy.acf_domains.assignedDomains', []); 

    const subtitle = get(pageProps, 'data.ambassadorBy.acf_ambassador.amSubtitle', null);
    const hashtag = get(pageProps, 'data.ambassadorBy.acf_ambassador.amHashtag', null);
    const fbPageId = get(pageProps, 'data.ambassadorBy.acf_ambassador.amFbPageId', null);

    // breadcrumbs
    // Hardcoded due to CMS ambassadors post permalink is different with site page URLs
    const ambassadorUri = uri.replace('-ccau', '').replace('-ccnz', '');
    const breadcrumbs = {
      list: [
        {
          link: {
            title: 'Home',
            href: '/',
            target: '_self',
            assignedDomains
          },
          active: false
        },
        {
          link: {
            title: 'Ambassadors',
            href: '/ambassadors',
            target: '_self',
            assignedDomains
          },
          active: false
        },
        {
          link: {
            title: startCase(toLower(ambassadorUri)),
            href: '/ambassadors/' + ambassadorUri,
            target: '_self',
            assignedDomains
          },
          active: true
        }
      ]
    };

    const ambassadorImage = image ? refactorRespImg(image, [{
      size: 'default',
      key: 'image_size_760x516'
    }]) : null;

    const data = {
      meta: {
        title,
        seo,
        assignedDomains
      },
      breadcrumbs,
      heroBanner,
      title,
      description,
      ambassadorImage,
      facebook,
      instagram,
      youtube,
      linkedIn,
      twitter,
      relatedArticles,
      subtitle,
      hashtag,
      fbPageId
    }

    return {
      revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
      props: {
        ...data,
      }
    }
  } else { 
    return { 
      revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
      props: {} 
    }
  }
}

export default Ambassadors
